import React from 'react';
import { Link } from 'react-router-dom';

export const VolEarthquakeModal = {
  title: 'Earthquake',
  body: (
    <div>
      <p>
        A value would indicate that there was a significant earthquake in conjunction with the volcanic eruption. The link connects to the event associated with the eruption in
        {' '}
        <Link to="/view/hazards/earthquake/search" target="_blank" rel="noopener noreferrer">Significant Earthquake Database.</Link>
      </p>
    </div>
  ),
};
